export default {
  BASEBALL: 'baseball',
  FOOTBALL: 'football',
  SOCCER: 'soccer',
  SOFTBALL: 'softball'
}
